import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

function ImageCirclePack(props) {
    const {circles, width, height, store, legendSvg} = props;
    const selections = store.persistStore.selectedMoodBoardKeys;

    // console.log(selections);
    const getStroke = (id) => {
        return (selections && selections.indexOf(id) >= 0) ? '#ffffff' : 'none';
    };
    return (
        <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
                {circles.map(({id, src}, i) =>
                    <pattern key={`p_${i}`} id={`pattern_${id}`} patternUnits="objectBoundingBox" viewBox="0 0 600 600" x="0" y="0" height="1" width="1">
                        <image x="0" y="0" width="600" height="600" xlinkHref={src}/>
                    </pattern>
                )}
            </defs>
            <g className={'ImageCirclePack'}>
                {circles.map(({x, y, r, id}, i) =>
                    <g key={`r_${i}`}>
                        <circle className="packed-image" cx={x} cy={y} r={r} fill={`url(#pattern_${id})`} strokeWidth={3} stroke={getStroke(id)}/>
                    </g>
                )}
            </g>
            {legendSvg}
        </svg>
    );
}

ImageCirclePack.defaultProps = {
    width: 400,
    height: 400,
};

export default observer(ImageCirclePack);







